<wl-structured-data [structuredData]="structuredData()"></wl-structured-data>
<wl-content-section>
  <wl-faq [feedbackSettings]="feedbackSettings()" [faq]="faq()" />
</wl-content-section>
